var exports = {
  "v": "banner__2k5s52",
};

module.exports = exports;
